export default __webpack_public_path__ + "static/media/i026vp.e303bba9.webp";